export enum PeriodUnit {
    Month = 'Month',
    Year = 'Year'
}
